export const canvasHashCache = new WeakMap<HTMLCanvasElement, string>();
